module.exports = __webpack_public_path__ + "static/doggify-invoice-43f2f412be792ee52ad2ed077300972a.webp";